'use strict';

const React = require('react');
const PropTypes = require('prop-types');
const { Component } = React;
const { QueryRenderer } = require('react-relay');
const { getUserId, cookieJarConstants, getEverLoggedIn } = require('dibs-cookie-jar');

const { constants: authConstants } = require('dibs-buyer-layout/src/utils/AuthModalLoader').default;
const getEnvironment = require('../../../global/relayModernEnvironment.es').default;
const { abExperiments } = require('dibs-buyer-layout/src/entries/index');

const MultiContactDealerModalRenderer = require('./MultiContactDealerModalRenderer');

let optimizelyVariant = 'control';
if (abExperiments.guidedContactDealer) {
    Promise.resolve(abExperiments.guidedContactDealer).then(res => {
        optimizelyVariant = res;
    });
}

const environment = getEnvironment();

class ContactDealerRenderer extends Component {
    startAuth({ callback, options }) {
        const { modalProps } = this.props;
        return modalProps
            .authProcess({
                email: options.emailValue,
                dealerName: options.dealerName,
                action: options.userExists ? authConstants.LOGIN : authConstants.REGISTER,
            })
            .then(userJSON => {
                this.forceUpdate(); // set new environment user token
                callback({
                    authAction: userJSON.newUser ? authConstants.REGISTER : authConstants.LOGIN,
                });
            });
    }

    render() {
        const { modalProps } = this.props;
        const { queries } = modalProps;
        const {
            PreContactDealer,
            Confirmation,
            ContactDealer,
            ContactDealerModal,
            PlainContactDealerModal,
            GuidedCopy,
            LowBall,
            MakeOffer,
            ModalWrapper,
        } = modalProps.modalComponents;
        const {
            itemPk,
            dealerPk,
            currentStep,
            isVerifiedTrade,
            isRequestMoreImages,
            bulkHoldRequest,
            onClose,
        } = modalProps;
        const showMultiRequestModal =
            !isRequestMoreImages && currentStep === 'contactDealer' && isVerifiedTrade;

        const userId = getUserId(document.cookie, cookieJarConstants.MASQUERADE_BUYER);

        // used for A/B test GA tracking (MCPERSON-2909 & MCPERSON-2910)
        const userHasEverLoggedIn = !!getEverLoggedIn(document.cookie);

        let variables = {
            shouldFetchItem: !!itemPk,
            shouldFetchImage: optimizelyVariant === 'contactDealerSidebar',
            hasUserId: !!userId,
            shouldFetchUser: !!userId,
            shouldFetchBuyerItemConv: !!itemPk && !!userId,
            shouldFetchUserAndItem: !!itemPk && !!userId,
            itemId: itemPk || null,
            itemIds: [itemPk],
            sellerId: dealerPk || "",
            hasSellerId: !bulkHoldRequest && !!dealerPk,
            userId,
            userIds: [userId],
        };

        const forceEnvironmentUpdate = variablesToSet => {
            // manually set variables in the queryConfig because relay.setVariables
            // causes a re-render, and we're already forcing a re-render with forceUpdate
            variables = Object.assign({}, variables, variablesToSet);
            this.forceUpdate();
        };

        if (showMultiRequestModal || bulkHoldRequest) {
            return (
                <PlainContactDealerModal isOpen onClose={onClose}>
                    <MultiContactDealerModalRenderer
                        showMultiRequestModal={showMultiRequestModal}
                        bulkHoldRequest={bulkHoldRequest}
                        environment={environment}
                        variables={variables}
                        modalProps={modalProps}
                        forceEnvironmentUpdate={forceEnvironmentUpdate}
                    />
                </PlainContactDealerModal>
            );
        }

        return (
            <QueryRenderer
                Container={ContactDealerModal}
                environment={environment}
                query={queries.contactDealer}
                variables={variables}
                render={({ error, props }) => {
                    if (props) {
                        const contactDealerProps = Object.assign({}, modalProps, props, {
                            forceEnvironmentUpdate,
                            userHasEverLoggedIn,
                            optimizelyVariant,
                        });

                        return (
                            <ContactDealerModal {...contactDealerProps}>
                                <GuidedCopy />
                                <ContactDealer />
                                <Confirmation />
                                <MakeOffer isContactDealer />
                                <LowBall />
                                <PreContactDealer />
                            </ContactDealerModal>
                        );
                    }

                    return <ModalWrapper openOnRender isError={!!error} isLoading={!props} />;
                }}
            />
        );
    }
}

ContactDealerRenderer.propTypes = {
    queryProps: PropTypes.object,
    modalProps: PropTypes.object,
};

module.exports = ContactDealerRenderer;



// WEBPACK FOOTER //
// ./assets/js/contact/dealer/components/ContactDealerRenderer.jsx